import { Api } from '@/api/api';
import { CreatePartnerPracticeRequest } from '@/api/requests/partner-practices/create-partner-practice-request';
import { PartnerPracticeRequestFilters } from '@/api/requests/partner-practices/partner-practice-request-filters';
import { UpdatePartnerPracticeRequest } from '@/api/requests/partner-practices/update-partner-practice-request';
import { PartnerPracticeResponse } from '@/api/responses/partner-practices/partner-practices-response';
import { PartnerPractice } from '@/shared/partner-practice';

export class PartnerPracticeApi extends Api {
    public async getPartnerPracticesAsync(filters: PartnerPracticeRequestFilters | null = null): Promise<PartnerPracticeResponse> {
        return this.getAsync<PartnerPracticeResponse>(`v1/partnerpractice`, filters);
    }

    public async getPartnerPracticeAsync(id: string): Promise<PartnerPractice> {

        return this.getAsync<PartnerPractice>(`v1/partnerpractice/${id}`);
    }

    public async createPartnerPracticeAsync(request: CreatePartnerPracticeRequest): Promise<string> {
        return this.postAsync<string>(`v1/partnerpractice`, { ...request });
    }


    public async deletePartnerPracticeAsync(partnerPractice: PartnerPractice): Promise<void> {
        await this.deleteAsync(`v1/partnerpractice/${partnerPractice.id}`);
    }

    public async updatePartnerPracticeAsync(request: UpdatePartnerPracticeRequest): Promise<void> {
        await this.putAsync(`v1/partnerpractice/${request.id}`, { ...request });
    }

    public constructor() {
        super();
    }
}
